import "./VehiclesTypeStatistic.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useRef } from "react";

import { Box } from "@mui/material";

import ReactECharts from "echarts-for-react";

import { fetchVehicleType } from "../../slices/transportStatistic";

const mapToSeriesWithOther = (obj = {}, limit = 12) => {
    const entries = Object.entries(obj).map(([k,v]) => [k, Number(v)||0]).sort((a,b)=>b[1]-a[1]);
    const top = entries.slice(0, limit);
    const other = entries.slice(limit).reduce((s,[,v])=>s+v,0);
    if (other>0) top.push(['Остальное', other]);
    return { categories: top.map(([k])=>k), values: top.map(([,v])=>v) };
};

const VehicleTypeStatistic = ({ params }) => {
    const dispatch = useDispatch();
    const token = useSelector((s) => s.auth.token?.data?.token || s.auth.token);
    const dataMap = useSelector((s) => s.transportStatistic.transportType);
    const chartRef = useRef(null);

    useEffect(() => { dispatch(fetchVehicleType({ token, params })); }, [dispatch, token, params]);
    useEffect(() => {
        const t = setTimeout(() => chartRef.current?.getEchartsInstance().resize(), 120);
        return () => clearTimeout(t);
    }, [dataMap]);

    const { categories, values } = mapToSeriesWithOther(dataMap, 12);

    const options = {
        title: { text: 'Тип транспорта', left: 'center' },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '3%', right: '4%', bottom: '20%', containLabel: true },
        xAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
                rotate: 35,
                fontSize: 10,
                interval: 0,
                width: 80,
                overflow: 'truncate',
            }
        },

        yAxis: { type: 'value' },
        series: [{
            type: 'bar',
            data: values,
            barWidth: '55%',
            itemStyle: {
                color: '#0891B2',
            },
            emphasis: {
                itemStyle: {
                    color: '#0E7490'
                }
            }
        }]
    };

    return <Box className="vehicle_type_statistic"><ReactECharts ref={chartRef} option={options} style={{ width:'100%', height:'100%' }} /></Box>;
};

export default VehicleTypeStatistic;